module.exports = __webpack_public_path__ + "static/media/Keunbon Translated by J_Lee_77777.6e4b5849.md";